export const qualitativeColors = [
  "#0969da", "#1a7f37", "#8250df", "#bf3989",
  "#bc4c00", "#cf222e", "#007d9c", "#596900",
  "#9a6700", "#57606a", "#0550ae", "#6e40c9"
];
export const avatarColors = qualitativeColors.slice(0, 6);

export function deterministicColor(value, palette = qualitativeColors) {
  return palette[deterministicColorIndex(value, palette.length)];
}

export function deterministicColorIndex(value, colorCount = qualitativeColors.length) {
  const normalizedValue = String(value ?? "").trim().normalize("NFKC").toLowerCase();
  let hash = 2166136261;
  for (const character of normalizedValue) {
    hash ^= character.codePointAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) % colorCount;
}
